module.exports = __webpack_public_path__ + "img/edge_activites_cinema.a1dcc6fe.svg";